// src/pages/calidad/QuejasClienteReporte.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

const CLASIFICACION_COLOR = {
  Inocuidad: { bg: '#FDF3F1', color: '#B23A48' },
  Calidad: { bg: '#FFF6E9', color: '#B2662A' },
  'Calidad sensorial': { bg: '#EFE9F3', color: '#6A2C75' },
  'E-commerce': { bg: '#EEF3FA', color: '#2E5C8A' },
};

const MESES_CORTO = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export default function QuejasClienteReporte() {
  const [reporte, setReporte] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroClasificacion, setFiltroClasificacion] = useState('');

  async function cargar() {
    setCargando(true);
    try {
      const [resReporte, resHistorial] = await Promise.all([
        api.get('/api/calidad/quejas-cliente/reporte'),
        api.get('/api/calidad/quejas-cliente', { params: { clasificacion: filtroClasificacion || undefined } }),
      ]);
      setReporte(resReporte.data.data);
      setHistorial(resHistorial.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, [filtroClasificacion]); // eslint-disable-line react-hooks/exhaustive-deps

  const ultimo = reporte[reporte.length - 1];
  const anterior = reporte[reporte.length - 2];
  const maxPct = Math.max(1, ...reporte.map((r) => r.quejas_por_50000 || 0));

  if (cargando && reporte.length === 0) return <div style={styles.contenedor}>Cargando...</div>;

  return (
    <div style={styles.contenedor} className="contenedor-captura">
      <h1 style={styles.titulo}>5.2 Quejas de Cliente</h1>
      <p style={styles.subtitulo}>Quejas por cada 50,000 piezas producidas. Meta dura: 0 quejas por Inocuidad al mes.</p>

      <div style={styles.tarjetasResumen}>
        <div style={styles.tarjetaKpi}>
          <div style={styles.kpiLabel}>{ultimo ? `${MESES_CORTO[ultimo.mes - 1]} ${ultimo.anio}` : 'Mes más reciente'}</div>
          <div style={{ ...styles.kpiValor, color: ultimo?.quejas_inocuidad > 0 ? '#B23A48' : '#2A1830' }}>
            {ultimo?.quejas_por_50000 !== null && ultimo?.quejas_por_50000 !== undefined ? ultimo.quejas_por_50000 : '—'}
          </div>
          <div style={styles.kpiDetalle}>
            {ultimo ? `${ultimo.total_quejas} quejas / ${ultimo.piezas_producidas ?? '?'} piezas` : ''}
          </div>
          {ultimo?.quejas_inocuidad > 0 && (
            <div style={styles.avisoInocuidad}>⚠ {ultimo.quejas_inocuidad} queja(s) de Inocuidad este mes</div>
          )}
        </div>
        <div style={styles.tarjetaKpi}>
          <div style={styles.kpiLabel}>{anterior ? `${MESES_CORTO[anterior.mes - 1]} ${anterior.anio}` : 'Mes anterior'}</div>
          <div style={styles.kpiValor}>{anterior?.quejas_por_50000 !== null && anterior?.quejas_por_50000 !== undefined ? anterior.quejas_por_50000 : '—'}</div>
          <div style={styles.kpiDetalle}>{anterior ? `${anterior.total_quejas} quejas / ${anterior.piezas_producidas ?? '?'} piezas` : ''}</div>
        </div>
      </div>

      <div style={styles.tarjeta}>
        <div style={styles.seccionTitulo}>Tendencia mensual</div>
        <div style={styles.grafica}>
          {reporte.map((r) => (
            <div key={`${r.anio}-${r.mes}`} style={styles.barraContenedor}>
              <div
                style={{
                  ...styles.barra,
                  height: `${((r.quejas_por_50000 || 0) / maxPct) * 100}%`,
                  background: r.quejas_inocuidad > 0 ? '#B23A48' : '#6A2C75',
                }}
              />
              <div style={styles.barraValor}>{r.quejas_por_50000 ?? '—'}</div>
              <div style={styles.barraFecha}>{MESES_CORTO[r.mes - 1]} {String(r.anio).slice(-2)}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.seccionTitulo2}>Historial de quejas</div>
      <div style={styles.filtros}>
        <select value={filtroClasificacion} onChange={(e) => setFiltroClasificacion(e.target.value)} style={styles.input}>
          <option value="">Todas las clasificaciones</option>
          <option value="Inocuidad">Inocuidad</option>
          <option value="Calidad">Calidad</option>
          <option value="Calidad sensorial">Calidad sensorial</option>
          <option value="E-commerce">E-commerce</option>
        </select>
      </div>

      <div style={styles.tarjeta}>
        {historial.length === 0 ? (
          <div style={styles.vacio}>Sin quejas capturadas para este filtro.</div>
        ) : (
          historial.map((q) => {
            const colorClas = CLASIFICACION_COLOR[q.clasificacion] || { bg: '#F0E9E0', color: '#3A2E42' };
            return (
              <div key={q.id} style={styles.filaQueja}>
                <div>
                  <div style={styles.nombreQueja}>{q.cliente} {q.sku ? `— ${q.sku}` : ''}</div>
                  <div style={styles.detalleQueja}>{q.fecha_queja} · {q.tipo}</div>
                  <div style={styles.descripcionQueja}>{q.descripcion}</div>
                </div>
                <span style={{ ...styles.badgeClasificacion, background: colorClas.bg, color: colorClas.color }}>{q.clasificacion}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '820px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  tarjetasResumen: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px', marginBottom: '16px' },
  tarjetaKpi: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  kpiLabel: { fontSize: '11px', color: '#8A7690', marginBottom: '6px', fontWeight: 600 },
  kpiValor: { fontSize: '30px', fontWeight: 700 },
  kpiDetalle: { fontSize: '11px', color: '#8A7690', marginTop: '4px' },
  avisoInocuidad: { fontSize: '11px', fontWeight: 700, color: '#B23A48', marginTop: '8px' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', marginBottom: '16px' },
  seccionTitulo: { fontFamily: 'Playfair Display, serif', fontSize: '15px', color: '#2A1830', marginBottom: '14px' },
  seccionTitulo2: { fontFamily: 'Playfair Display, serif', fontSize: '16px', color: '#2A1830', marginBottom: '10px' },
  grafica: { display: 'flex', gap: '10px', alignItems: 'flex-end', height: '140px', paddingTop: '10px', overflowX: 'auto' },
  barraContenedor: { display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '0 0 50px', height: '100%', justifyContent: 'flex-end' },
  barra: { width: '24px', borderRadius: '4px 4px 0 0', minHeight: '4px' },
  barraValor: { fontSize: '11px', fontWeight: 700, color: '#2A1830', marginTop: '4px' },
  barraFecha: { fontSize: '9px', color: '#8A7690', marginTop: '2px', textAlign: 'center' },
  filtros: { display: 'flex', gap: '10px', marginBottom: '12px', flexWrap: 'wrap' },
  input: { padding: '8px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  vacio: { textAlign: 'center', color: '#8A7690', fontSize: '13px', padding: '10px' },
  filaQueja: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px', padding: '12px 0', borderBottom: '1px solid #F0E9E0', flexWrap: 'wrap' },
  nombreQueja: { fontSize: '13px', fontWeight: 700, color: '#2A1830' },
  detalleQueja: { fontSize: '11px', color: '#8A7690', marginTop: '2px' },
  descripcionQueja: { fontSize: '12px', color: '#3A2E42', marginTop: '4px' },
  badgeClasificacion: { fontSize: '11px', fontWeight: 700, borderRadius: '6px', padding: '3px 8px', whiteSpace: 'nowrap', flexShrink: 0 },
};